import { useQuery } from '@tanstack/react-query';
import { getCurrentUser } from '@kirin/api-client/api/account';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from './queryKeys';
import { cacheConfigForStaticReferenceData } from './queryConfig';
import { retryHandlers } from './helpers';

/**
 * Hook to fetch current user information
 *
 * Uses React Query for caching and automatic refetching.
 * User info is cached for 10 minutes since it rarely changes.
 *
 * @example
 * const { data: user, isLoading, error } = useCurrentUser();
 *
 * @returns React Query result with user data
 */
export function useCurrentUser() {
  return useQuery({
    queryKey: queryKeys.account.whoami,
    queryFn: () => getCurrentUser(apiClient),
    ...cacheConfigForStaticReferenceData,
    retry: retryHandlers.list,
  });
}
